import { render, staticRenderFns } from "./EditAktivitas.vue?vue&type=template&id=9b1145ee&scoped=true&lang=html&"
import script from "./EditAktivitas.vue?vue&type=script&lang=js&"
export * from "./EditAktivitas.vue?vue&type=script&lang=js&"
import style0 from "./EditAktivitas.vue?vue&type=style&index=0&id=9b1145ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1145ee",
  null
  
)

export default component.exports